import endangerment from '../assets/endangerment.json';

enum EndangermentStatus {
    EE = 'Extinct in the Wild',
    EX = 'Extinct',
    CR = 'Critically Endangered',
    EN = 'Endangered',
    VU = 'Vulnerable',
    NT = 'Near Threatened',
    LC = 'Least Concern',
    DD = 'Data Deficient',
    NE = 'Not Evaluated',
    UNKNOWN = 'Unknown'
}

const endangermentCodes = {
    ee: EndangermentStatus.EE,
    ex: EndangermentStatus.EX,
    cr: EndangermentStatus.CR,
    en: EndangermentStatus.EN,
    vu: EndangermentStatus.VU,
    nt: EndangermentStatus.NT,
    lc: EndangermentStatus.LC,
    dd: EndangermentStatus.DD,
    ne: EndangermentStatus.NE,
    unknown: EndangermentStatus.UNKNOWN
};

function getEndangermentCode(code: string): EndangermentStatus {
    return endangermentCodes[code.toLowerCase().trim()] || EndangermentStatus.UNKNOWN;
}

function getSpeciesEndangerment(species: string): EndangermentStatus {
    return getEndangermentCode(endangerment[species.toLowerCase().trim()] || 'unknown');
}

/**
 * @returns The button colour class and the short-form string name of the status
 */
function getEndangermentInfo(status: EndangermentStatus): { className: string; shortForm: string } {
    let className,
        shortForm = '';
    switch (status) {
        case EndangermentStatus.EE:
            className = 'btn-dark';
            shortForm = 'EE';
            break;
        case EndangermentStatus.EX:
            className = 'btn-dark';
            shortForm = 'EX';
            break;
        case EndangermentStatus.CR:
            className = 'btn-danger';
            shortForm = 'CR';
            break;
        case EndangermentStatus.EN:
            className = 'btn-danger';
            shortForm = 'EN';
            break;
        case EndangermentStatus.VU:
            className = 'btn-warning';
            shortForm = 'VU';
            break;
        case EndangermentStatus.NT:
            className = 'btn-warning';
            shortForm = 'NT';
            break;
        case EndangermentStatus.LC:
            className = 'btn-success';
            shortForm = 'LC';
            break;
        case EndangermentStatus.DD:
            className = 'btn-secondary';
            shortForm = 'DD';
            break;
        case EndangermentStatus.NE:
            className = 'btn-secondary';
            shortForm = 'NE';
            break;
        case EndangermentStatus.UNKNOWN:
            className = 'btn-secondary';
            shortForm = 'UNK';
            break;
    }
    return { className: className, shortForm: shortForm };
}

const endangermentValues = [
    EndangermentStatus.EE,
    EndangermentStatus.EX,
    EndangermentStatus.CR,
    EndangermentStatus.EN,
    EndangermentStatus.VU,
    EndangermentStatus.NT,
    EndangermentStatus.LC,
    EndangermentStatus.DD,
    EndangermentStatus.NE,
    EndangermentStatus.UNKNOWN
];

export { endangermentValues, EndangermentStatus, getSpeciesEndangerment, getEndangermentInfo };
